import React from "react";
import { Formik } from "formik";
import {
    TextField,
    withStyles,
    Button,
    Typography,
    CircularProgress,
    FormControl,
    InputLabel,
    MenuItem,
    Select
} from "@material-ui/core";
import * as Yup from "yup";
import { hasPermission } from "../../sc-utilities";
import {updateKey} from "../TypicalProblem/TypicalProblemForm";

export const types = [{value: "system", displayValue: "System grade"}, {value: "custom", displayValue: "Customer grade"}];

const styles = theme => ({
    root: {
        flexGrow: 1,
        paddingTop: theme.spacing(2)
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "100%",
        marginTop: "10px"
    },
    formControl: {
        width: "100%"
    }
});

const GradeForm = props => {
    const { classes, formSettings, initialValues, handleSubmit, translations, fromEdit, permissions, CustomerIDPreviousState } = props;

    return (
        <div className={classes.root}>
            <Formik
                initialValues={initialValues}
                onSubmit={async (values, { setSubmitting }) => {
                    setSubmitting(true);
                    await handleSubmit(values);
                    setSubmitting(false);

                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, isValid, dirty, isSubmitting, setFieldValue, handleChange, handleBlur, handleSubmit } = formikProps;
                    return (
                        <form onSubmit={handleSubmit}>
                            <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                            <TextField
                                name="Condition"
                                value={values.Condition}
                                onChange={(e) => {handleChange(e); setFieldValue('Key', updateKey(e.target.value))}}
                                onBlur={handleBlur}
                                error={!!(errors.Condition && touched.Condition)}
                                placeholder={translations["condition"] || "Condition"}
                                label={translations["condition"] || "Condition"}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="InternationalGrading"
                                value={values.InternationalGrading}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.InternationalGrading && touched.InternationalGrading)}
                                placeholder={translations["international_grading"] || "International Grading"}
                                label={translations["international_grading"] || "International Grading"}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            {hasPermission(permissions, 'system_grade_create') && 
                            <>
                                <FormControl className={classes.formControl} margin={"dense"}>
                                    <InputLabel
                                        shrink>{translations['please_select_grade_type'] || "Please select grade type"}</InputLabel>
                                    <Select
                                        name="CustomerID"
                                        label={translations['please_select_grade_type'] || 'Please select grade type'}
                                        margin={"dense"}
                                        value={values?.CustomerID?.toString() || ''}
                                        onChange={handleChange}
                                        disabled={values?.CustomerID?.toString() === 'system' && fromEdit && CustomerIDPreviousState==='system'}
                                    >
                                        {(types ? [...types] : []).map(option => (
                                            <MenuItem key={option.value} value={option.value.toString()}>
                                                {option.displayValue}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </>}

                            <div>
                                {formSettings.ButtonSubmit ? (
                                    <Button
                                        className={classes.submit}
                                        variant="contained"
                                        type="submit"
                                        disabled={isSubmitting || !(isValid && dirty)}
                                    >
                                        {(isSubmitting) ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                    </Button>
                                ) : null}
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </div>
    );
};

export default withStyles(styles, { withTheme: true })(GradeForm);
